var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"masked-text"},[_vm._v("\n  "+_vm._s(_vm.isVisible ? _vm.value : _vm.masked)+"\n\n  "),_vm._v(" "),(_vm.toggle)?_c('i',{staticClass:"ml-2 toggle-eye",class:_vm.isVisible ? 'fas fa-eye-slash' : 'fas fa-eye',on:{"click":_vm.toggleVisibility}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-610cf71b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/masking-view-data.vue
// module id = null
// module chunks = 